import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import GuideMeButton from '../components/GuideMeButton';
import Intro from '../components/Intro';
import HeroContext from '../PageContext';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '34px 0',
    minHeight: 230,
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      padding: 0,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  container: {
    [theme.breakpoints.up('1140')]: {
      width: 1140,
      padding: 0,
    },
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '24px 5%',
    [theme.breakpoints.down('600')]: {
      flexDirection: 'column',
    },
  },
  btnWrapper: {
    marginLeft: 100,
    '& button': {
      fontSize: 18,
      lineHeight: '23px',
      fontFamily: 'MadaBold',
    },
    '& > div': {
      flexBasis: 'auto',
    },
    [theme.breakpoints.down('600')]: {
      marginLeft: 0,
    },
  },
}));

function VariantI() {
  const classes = useStyles();
  const { clientInfo } = useContext(HeroContext);
  const { pageText } = clientInfo[0];
  const buttonJson = _get(pageText, 'button');
  const hasButtonJson =
    !_isEmpty(buttonJson) && _get(buttonJson, 'label', false);
  const shouldBreakTitle = _get(pageText, 'shouldBreakTitle', false);
  return (
    <div className={classes.root} data-test-id="hero-variant-i">
      <Box display="flex" className={classes.container}>
        <div>
          <Intro
            shouldBreakTitle={shouldBreakTitle}
            isLandingPage={false}
            maxWidth={367}
          />
        </div>
        {hasButtonJson && (
          <div className={classes.btnWrapper}>
            <GuideMeButton noGuideMe />
          </div>
        )}
      </Box>
    </div>
  );
}

export default VariantI;
